import DefaultMetaTags from '~/types/defaultMetaTags';
import { ICanonicalLink } from '~/types/ICanonicalLink';
import IMeta from '~/types/IMeta';
import IMetaOpenGraph from '~/types/IMetaOpenGraph';
import IMetaTag from '~/types/IMetaTag';
import { ISitemapa } from '~/types/IRouteInfo';

export interface IBuildMetaTagsInfo {
  sitemapa: ISitemapa | undefined;
  description: string;
  title: string;
  path: string;
  defaultMetaTags: DefaultMetaTags;
}

const buildMetaTags = (info: IBuildMetaTagsInfo): IMetaTag => {
  const { defaultMetaTags } = info;
  const { path } = info;
  const description = info.description || (defaultMetaTags.Description as string);
  const title = info.title || (defaultMetaTags.Title as string);
  const index: boolean | undefined = info.sitemapa?.Index;
  const follow: boolean | undefined = info.sitemapa?.Follow;
  const robotsContent = `${index || index === null || index === undefined ? '' : 'no'}index, ${
    follow || follow === null || follow === undefined ? '' : 'no'
  }follow`;

  const url = path.split('#');
  const routeAdress: string = `https://r.pl${url || ''}`;

  const result: IMetaTag = {
    title: title || (defaultMetaTags.Title as string),
    meta: [
      {
        hid: 'robotsIndexFollow',
        name: 'robots',
        content: robotsContent,
      } as IMeta,
      {
        hid: 'description',
        name: 'description',
        content: description,
      } as IMeta,
      {
        property: 'og:title',
        content: title,
      } as IMetaOpenGraph,
      {
        property: 'og:description',
        content: description,
      } as IMetaOpenGraph,
    ],
  };

  if (index) {
    result.link = [
      {
        hid: 'linkCannonical',
        rel: 'canonical',
        href: routeAdress,
      } as ICanonicalLink,
    ];
  }

  return result;
};

export default buildMetaTags;
